<template>
  <span v-if="d">
    {{ month() }} {{ day() }}, {{ year() }}
  </span>
</template>

<script>
  export default {
    name: 'FDate',
    components: {},
    props: ['d'],
    data () {
      return {
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },
    mounted () {
      return
    },
    computed:{
      dateObject(){
        return new Date(this.d)
      }
    },
    methods: {
      month () {
        return this.months[this.dateObject.getMonth()]
      },
      day () {
        return this.dateObject.getDate()
      },
      year () {
        return this.dateObject.getFullYear()
      }
    }
  }
</script>

<style scoped>

</style>
